var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoinIconSmall = function SvgCoinIconSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#5656FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9707 8.1394L7.79779 13.1502V15.8902H9.42517V13.1502L12.2523 8.1394H10.4167L8.64933 11.4774H8.57364L6.80623 8.1394H4.9707Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.352 10.3685H18.9226C18.8999 8.98715 17.7645 8.03343 16.0387 8.03343C14.3395 8.03343 13.0943 8.97201 13.1019 10.3799C13.0981 11.5228 13.9042 12.1776 15.2137 12.4917L16.0577 12.7036C16.9016 12.908 17.3709 13.1502 17.3747 13.6725C17.3709 14.2402 16.8335 14.6262 16.0009 14.6262C15.1494 14.6262 14.5363 14.2326 14.4833 13.4568H12.8975C12.9392 15.1333 14.1389 16 16.0198 16C17.9121 16 19.0248 15.0955 19.0286 13.6763C19.0248 12.3857 18.0522 11.7007 16.7048 11.3979L16.0085 11.2314C15.3348 11.0762 14.7709 10.8265 14.7823 10.2701C14.7823 9.77056 15.2251 9.40345 16.0274 9.40345C16.8108 9.40345 17.2914 9.75921 17.352 10.3685Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoinIconSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coinIconSmall.7ad12765.svg";
export { ForwardRef as ReactComponent };